import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  closeOnLinkClick(event) {
    if (event.target.closest("a")) {
      this.element.hidePopover()
    }
  }
}
